"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadCaptureFormCountryList = exports.getStatesByCountry = exports.StateMap = void 0;
const checkout_1 = require("../checkout");
exports.StateMap = new Map(Object.entries({
    AU: [
        {
            key: 'ACT',
            text: 'Australian Capital Territory',
            value: 'ACT',
        },
        {
            key: 'NSW',
            text: 'New South Wales',
            value: 'NSW',
        },
        {
            key: 'NT',
            text: 'Northern Territory',
            value: 'NT',
        },
        {
            key: 'QLD',
            text: 'Queensland',
            value: 'QLD',
        },
        {
            key: 'SA',
            text: 'South Australia',
            value: 'SA',
        },
        {
            key: 'TAS',
            text: 'Tasmania',
            value: 'TAS',
        },
        {
            key: 'VIC',
            text: 'Victoria',
            value: 'VIC',
        },
        {
            key: 'WA',
            text: 'Western Australia',
            value: 'WA',
        },
    ],
    BR: [
        {
            key: 'AC',
            text: 'Acre',
            value: 'AC',
        },
        {
            key: 'AL',
            text: 'Alagoas',
            value: 'AL',
        },
        {
            key: 'AM',
            text: 'Amazonas',
            value: 'AM',
        },
        {
            key: 'AP',
            text: 'Amapá',
            value: 'AP',
        },
        {
            key: 'BA',
            text: 'Bahia',
            value: 'BA',
        },
        {
            key: 'CE',
            text: 'Ceará',
            value: 'CE',
        },
        {
            key: 'DF',
            text: 'Distrito Federal',
            value: 'DF',
        },
        {
            key: 'ES',
            text: 'Espírito Santo',
            value: 'ES',
        },
        {
            key: 'GO',
            text: 'Goiás',
            value: 'GO',
        },
        {
            key: 'MA',
            text: 'Maranhão',
            value: 'MA',
        },
        {
            key: 'MG',
            text: 'Minas Gerais',
            value: 'MG',
        },
        {
            key: 'MS',
            text: 'Mato Grosso do Sul',
            value: 'MS',
        },
        {
            key: 'MT',
            text: 'Mato Grosso',
            value: 'MT',
        },
        {
            key: 'PA',
            text: 'Pará',
            value: 'PA',
        },
        {
            key: 'PB',
            text: 'Paraíba',
            value: 'PB',
        },
        {
            key: 'PE',
            text: 'Pernambuco',
            value: 'PE',
        },
        {
            key: 'PI',
            text: 'Piauí',
            value: 'PI',
        },
        {
            key: 'PR',
            text: 'Paraná',
            value: 'PR',
        },
        {
            key: 'RJ',
            text: 'Rio de Janeiro',
            value: 'RJ',
        },
        {
            key: 'RN',
            text: 'Rio Grande do Norte',
            value: 'RN',
        },
        {
            key: 'RO',
            text: 'Rondônia',
            value: 'RO',
        },
        {
            key: 'RR',
            text: 'Roraima',
            value: 'RR',
        },
        {
            key: 'RS',
            text: 'Rio Grande do Sul',
            value: 'RS',
        },
        {
            key: 'SC',
            text: 'Santa Catarina',
            value: 'SC',
        },
        {
            key: 'SE',
            text: 'Sergipe',
            value: 'SE',
        },
        {
            key: 'SP',
            text: 'São Paulo',
            value: 'SP',
        },
        {
            key: 'TO',
            text: 'Tocantins',
            value: 'TO',
        },
    ],
    CA: [
        {
            key: 'AB',
            text: 'Alberta',
            value: 'AB',
        },
        {
            key: 'BC',
            text: 'British Columbia',
            value: 'BC',
        },
        {
            key: 'MB',
            text: 'Manitoba',
            value: 'MB',
        },
        {
            key: 'NB',
            text: 'New Brunswick',
            value: 'NB',
        },
        {
            key: 'NL',
            text: 'Newfoundland and Labrador',
            value: 'NL',
        },
        {
            key: 'NS',
            text: 'Nova Scotia',
            value: 'NS',
        },
        {
            key: 'NT',
            text: 'Northwest Territories',
            value: 'NT',
        },
        {
            key: 'NU',
            text: 'Nunavut',
            value: 'NU',
        },
        {
            key: 'ON',
            text: 'Ontario',
            value: 'ON',
        },
        {
            key: 'PE',
            text: 'Prince Edward Island',
            value: 'PE',
        },
        {
            key: 'QC',
            text: 'Quebec',
            value: 'QC',
        },
        {
            key: 'SK',
            text: 'Saskatchewan',
            value: 'SK',
        },
        {
            key: 'YT',
            text: 'Yukon Territories',
            value: 'YT',
        },
    ],
    CN: [
        {
            key: '11',
            text: 'Beijing',
            value: '11',
        },
        {
            key: '12',
            text: 'Tianjin',
            value: '12',
        },
        {
            key: '13',
            text: 'Hebei',
            value: '13',
        },
        {
            key: '14',
            text: 'Shanxi',
            value: '14',
        },
        {
            key: '15',
            text: 'Nei Mongol',
            value: '15',
        },
        {
            key: '21',
            text: 'Liaoning',
            value: '21',
        },
        {
            key: '22',
            text: 'Jilin',
            value: '22',
        },
        {
            key: '23',
            text: 'Heilongjiang',
            value: '23',
        },
        {
            key: '31',
            text: 'Shanghai',
            value: '31',
        },
        {
            key: '32',
            text: 'Jiangsu',
            value: '32',
        },
        {
            key: '33',
            text: 'Zhejiang',
            value: '33',
        },
        {
            key: '34',
            text: 'Anhui',
            value: '34',
        },
        {
            key: '35',
            text: 'Fujian',
            value: '35',
        },
        {
            key: '36',
            text: 'Jiangxi',
            value: '36',
        },
        {
            key: '37',
            text: 'Shandong',
            value: '37',
        },
        {
            key: '41',
            text: 'Henan',
            value: '41',
        },
        {
            key: '42',
            text: 'Hubei',
            value: '42',
        },
        {
            key: '43',
            text: 'Hunan',
            value: '43',
        },
        {
            key: '44',
            text: 'Guangdong',
            value: '44',
        },
        {
            key: '45',
            text: 'Guangxi',
            value: '45',
        },
        {
            key: '46',
            text: 'Hainan',
            value: '46',
        },
        {
            key: '50',
            text: 'Chongqing',
            value: '50',
        },
        {
            key: '51',
            text: 'Sichuan',
            value: '51',
        },
        {
            key: '52',
            text: 'Guizhou',
            value: '52',
        },
        {
            key: '53',
            text: 'Yunnan',
            value: '53',
        },
        {
            key: '54',
            text: 'Xizang',
            value: '54',
        },
        {
            key: '61',
            text: 'Shaanxi',
            value: '61',
        },
        {
            key: '62',
            text: 'Gansu',
            value: '62',
        },
        {
            key: '63',
            text: 'Qinghai',
            value: '63',
        },
        {
            key: '64',
            text: 'Ningxia',
            value: '64',
        },
        {
            key: '65',
            text: 'Xinjiang',
            value: '65',
        },
        {
            key: '71',
            text: 'Chinese Taipei',
            value: '71',
        },
        {
            key: '91',
            text: 'Hong Kong SAR, China',
            value: '91',
        },
        {
            key: '92',
            text: 'Macao SAR, China',
            value: '92',
        },
    ],
    IN: [
        {
            key: 'AN',
            text: 'Andaman and Nicobar Islands',
            value: 'AN',
        },
        {
            key: 'AP',
            text: 'Andhra Pradesh',
            value: 'AP',
        },
        {
            key: 'AR',
            text: 'Arunachal Pradesh',
            value: 'AR',
        },
        {
            key: 'AS',
            text: 'Assam',
            value: 'AS',
        },
        {
            key: 'BR',
            text: 'Bihar',
            value: 'BR',
        },
        {
            key: 'CH',
            text: 'Chandigarh',
            value: 'CH',
        },
        {
            key: 'CT',
            text: 'Chhattisgarh',
            value: 'CT',
        },
        {
            key: 'DD',
            text: 'Daman and Diu',
            value: 'DD',
        },
        {
            key: 'DL',
            text: 'Delhi',
            value: 'DL',
        },
        {
            key: 'DN',
            text: 'Dadra and Nagar Haveli',
            value: 'DN',
        },
        {
            key: 'GA',
            text: 'Goa',
            value: 'GA',
        },
        {
            key: 'GJ',
            text: 'Gujarat',
            value: 'GJ',
        },
        {
            key: 'HP',
            text: 'Himachal Pradesh',
            value: 'HP',
        },
        {
            key: 'HR',
            text: 'Haryana',
            value: 'HR',
        },
        {
            key: 'JH',
            text: 'Jharkhand',
            value: 'JH',
        },
        {
            key: 'JK',
            text: 'Jammu and Kashmir',
            value: 'JK',
        },
        {
            key: 'KA',
            text: 'Karnataka',
            value: 'KA',
        },
        {
            key: 'KL',
            text: 'Kerala',
            value: 'KL',
        },
        {
            key: 'LD',
            text: 'Lakshadweep',
            value: 'LD',
        },
        {
            key: 'MH',
            text: 'Maharashtra',
            value: 'MH',
        },
        {
            key: 'ML',
            text: 'Meghalaya',
            value: 'ML',
        },
        {
            key: 'MN',
            text: 'Manipur',
            value: 'MN',
        },
        {
            key: 'MP',
            text: 'Madhya Pradesh',
            value: 'MP',
        },
        {
            key: 'MZ',
            text: 'Mizoram',
            value: 'MZ',
        },
        {
            key: 'NL',
            text: 'Nagaland',
            value: 'NL',
        },
        {
            key: 'OR',
            text: 'Odisha',
            value: 'OR',
        },
        {
            key: 'PB',
            text: 'Punjab',
            value: 'PB',
        },
        {
            key: 'PY',
            text: 'Puducherry',
            value: 'PY',
        },
        {
            key: 'RJ',
            text: 'Rajasthan',
            value: 'RJ',
        },
        {
            key: 'SK',
            text: 'Sikkim',
            value: 'SK',
        },
        {
            key: 'TN',
            text: 'Tamil Nadu',
            value: 'TN',
        },
        {
            key: 'TR',
            text: 'Tripura',
            value: 'TR',
        },
        {
            key: 'UP',
            text: 'Uttar Pradesh',
            value: 'UP',
        },
        {
            key: 'UT',
            text: 'Uttarakhand',
            value: 'UT',
        },
        {
            key: 'WB',
            text: 'West Bengal',
            value: 'WB',
        },
    ],
    IE: [
        {
            key: 'ANT',
            text: 'Co. Antrim',
            value: 'ANT',
        },
        {
            key: 'ARM',
            text: 'Co. Armagh',
            value: 'ARM',
        },
        {
            key: 'CE',
            text: 'Clare',
            value: 'CE',
        },
        {
            key: 'CN',
            text: 'Cavan',
            value: 'CN',
        },
        {
            key: 'CO',
            text: 'Cork',
            value: 'CO',
        },
        {
            key: 'CW',
            text: 'Carlow',
            value: 'CW',
        },
        {
            key: 'D',
            text: 'Dublin',
            value: 'D',
        },
        {
            key: 'DL',
            text: 'Donegal',
            value: 'DL',
        },
        {
            key: 'DOW',
            text: 'Co. Down',
            value: 'DOW',
        },
        {
            key: 'FER',
            text: 'Co. Fermanagh',
            value: 'FER',
        },
        {
            key: 'G',
            text: 'Galway',
            value: 'G',
        },
        {
            key: 'KE',
            text: 'Kildare',
            value: 'KE',
        },
        {
            key: 'KK',
            text: 'Kilkenny',
            value: 'KK',
        },
        {
            key: 'KY',
            text: 'Kerry',
            value: 'KY',
        },
        {
            key: 'LD',
            text: 'Longford',
            value: 'LD',
        },
        {
            key: 'LDY',
            text: 'Co. Londonderry',
            value: 'LDY',
        },
        {
            key: 'LH',
            text: 'Louth',
            value: 'LH',
        },
        {
            key: 'LK',
            text: 'Limerick',
            value: 'LK',
        },
        {
            key: 'LM',
            text: 'Leitrim',
            value: 'LM',
        },
        {
            key: 'LS',
            text: 'Laois',
            value: 'LS',
        },
        {
            key: 'MH',
            text: 'Meath',
            value: 'MH',
        },
        {
            key: 'MN',
            text: 'Monaghan',
            value: 'MN',
        },
        {
            key: 'MO',
            text: 'Mayo',
            value: 'MO',
        },
        {
            key: 'OY',
            text: 'Offaly',
            value: 'OY',
        },
        {
            key: 'RN',
            text: 'Roscommon',
            value: 'RN',
        },
        {
            key: 'SO',
            text: 'Sligo',
            value: 'SO',
        },
        {
            key: 'TA',
            text: 'Tipperary',
            value: 'TA',
        },
        {
            key: 'TYR',
            text: 'Co. Tyrone',
            value: 'TYR',
        },
        {
            key: 'WD',
            text: 'Waterford',
            value: 'WD',
        },
        {
            key: 'WH',
            text: 'Westmeath',
            value: 'WH',
        },
        {
            key: 'WW',
            text: 'Wicklow',
            value: 'WW',
        },
        {
            key: 'WX',
            text: 'Wexford',
            value: 'WX',
        },
    ],
    IT: [
        {
            key: 'AG',
            text: 'Agrigento',
            value: 'AG',
        },
        {
            key: 'AL',
            text: 'Alessandria',
            value: 'AL',
        },
        {
            key: 'AN',
            text: 'Ancona',
            value: 'AN',
        },
        {
            key: 'AO',
            text: 'Aosta',
            value: 'AO',
        },
        {
            key: 'AP',
            text: 'Ascoli Piceno',
            value: 'AP',
        },
        {
            key: 'AQ',
            text: "L'Aquila",
            value: 'AQ',
        },
        {
            key: 'AR',
            text: 'Arezzo',
            value: 'AR',
        },
        {
            key: 'AT',
            text: 'Asti',
            value: 'AT',
        },
        {
            key: 'AV',
            text: 'Avellino',
            value: 'AV',
        },
        {
            key: 'BA',
            text: 'Bari',
            value: 'BA',
        },
        {
            key: 'BG',
            text: 'Bergamo',
            value: 'BG',
        },
        {
            key: 'BI',
            text: 'Biella',
            value: 'BI',
        },
        {
            key: 'BL',
            text: 'Belluno',
            value: 'BL',
        },
        {
            key: 'BN',
            text: 'Benevento',
            value: 'BN',
        },
        {
            key: 'BO',
            text: 'Bologna',
            value: 'BO',
        },
        {
            key: 'BR',
            text: 'Brindisi',
            value: 'BR',
        },
        {
            key: 'BS',
            text: 'Brescia',
            value: 'BS',
        },
        {
            key: 'BT',
            text: 'Barletta-Andria-Trani',
            value: 'BT',
        },
        {
            key: 'BZ',
            text: 'Bolzano',
            value: 'BZ',
        },
        {
            key: 'CA',
            text: 'Cagliari',
            value: 'CA',
        },
        {
            key: 'CB',
            text: 'Campobasso',
            value: 'CB',
        },
        {
            key: 'CE',
            text: 'Caserta',
            value: 'CE',
        },
        {
            key: 'CH',
            text: 'Chieti',
            value: 'CH',
        },
        {
            key: 'CI',
            text: 'Carbonia-Iglesias',
            value: 'CI',
        },
        {
            key: 'CL',
            text: 'Caltanissetta',
            value: 'CL',
        },
        {
            key: 'CN',
            text: 'Cuneo',
            value: 'CN',
        },
        {
            key: 'CO',
            text: 'Como',
            value: 'CO',
        },
        {
            key: 'CR',
            text: 'Cremona',
            value: 'CR',
        },
        {
            key: 'CS',
            text: 'Cosenza',
            value: 'CS',
        },
        {
            key: 'CT',
            text: 'Catania',
            value: 'CT',
        },
        {
            key: 'CZ',
            text: 'Catanzaro',
            value: 'CZ',
        },
        {
            key: 'EN',
            text: 'Enna',
            value: 'EN',
        },
        {
            key: 'FC',
            text: 'Forlì-Cesena',
            value: 'FC',
        },
        {
            key: 'FE',
            text: 'Ferrara',
            value: 'FE',
        },
        {
            key: 'FG',
            text: 'Foggia',
            value: 'FG',
        },
        {
            key: 'FI',
            text: 'Florence',
            value: 'FI',
        },
        {
            key: 'FM',
            text: 'Fermo',
            value: 'FM',
        },
        {
            key: 'FR',
            text: 'Frosinone',
            value: 'FR',
        },
        {
            key: 'GE',
            text: 'Genoa',
            value: 'GE',
        },
        {
            key: 'GO',
            text: 'Gorizia',
            value: 'GO',
        },
        {
            key: 'GR',
            text: 'Grosseto',
            value: 'GR',
        },
        {
            key: 'IM',
            text: 'Imperia',
            value: 'IM',
        },
        {
            key: 'IS',
            text: 'Isernia',
            value: 'IS',
        },
        {
            key: 'KR',
            text: 'Crotone',
            value: 'KR',
        },
        {
            key: 'LC',
            text: 'Lecco',
            value: 'LC',
        },
        {
            key: 'LE',
            text: 'Lecce',
            value: 'LE',
        },
        {
            key: 'LI',
            text: 'Livorno',
            value: 'LI',
        },
        {
            key: 'LO',
            text: 'Lodi',
            value: 'LO',
        },
        {
            key: 'LT',
            text: 'Latina',
            value: 'LT',
        },
        {
            key: 'LU',
            text: 'Lucca',
            value: 'LU',
        },
        {
            key: 'MB',
            text: 'Monza and Brianza',
            value: 'MB',
        },
        {
            key: 'MC',
            text: 'Macerata',
            value: 'MC',
        },
        {
            key: 'ME',
            text: 'Messina',
            value: 'ME',
        },
        {
            key: 'MI',
            text: 'Milan',
            value: 'MI',
        },
        {
            key: 'MN',
            text: 'Mantua',
            value: 'MN',
        },
        {
            key: 'MO',
            text: 'Modena',
            value: 'MO',
        },
        {
            key: 'MS',
            text: 'Massa and Carrara',
            value: 'MS',
        },
        {
            key: 'MT',
            text: 'Matera',
            value: 'MT',
        },
        {
            key: 'NA',
            text: 'Naples',
            value: 'NA',
        },
        {
            key: 'NO',
            text: 'Novara',
            value: 'NO',
        },
        {
            key: 'NU',
            text: 'Nuoro',
            value: 'NU',
        },
        {
            key: 'OG',
            text: 'Ogliastra',
            value: 'OG',
        },
        {
            key: 'OR',
            text: 'Oristano',
            value: 'OR',
        },
        {
            key: 'OT',
            text: 'Olbia-Tempio',
            value: 'OT',
        },
        {
            key: 'PA',
            text: 'Palermo',
            value: 'PA',
        },
        {
            key: 'PC',
            text: 'Piacenza',
            value: 'PC',
        },
        {
            key: 'PD',
            text: 'Padua',
            value: 'PD',
        },
        {
            key: 'PE',
            text: 'Pescara',
            value: 'PE',
        },
        {
            key: 'PG',
            text: 'Perugia',
            value: 'PG',
        },
        {
            key: 'PI',
            text: 'Pisa',
            value: 'PI',
        },
        {
            key: 'PN',
            text: 'Pordenone',
            value: 'PN',
        },
        {
            key: 'PO',
            text: 'Prato',
            value: 'PO',
        },
        {
            key: 'PR',
            text: 'Parma',
            value: 'PR',
        },
        {
            key: 'PT',
            text: 'Pistoia',
            value: 'PT',
        },
        {
            key: 'PU',
            text: 'Pesaro and Urbino',
            value: 'PU',
        },
        {
            key: 'PV',
            text: 'Pavia',
            value: 'PV',
        },
        {
            key: 'PZ',
            text: 'Potenza',
            value: 'PZ',
        },
        {
            key: 'RA',
            text: 'Ravenna',
            value: 'RA',
        },
        {
            key: 'RC',
            text: 'Reggio Calabria',
            value: 'RC',
        },
        {
            key: 'RE',
            text: 'Reggio Emilia',
            value: 'RE',
        },
        {
            key: 'RG',
            text: 'Ragusa',
            value: 'RG',
        },
        {
            key: 'RI',
            text: 'Rieti',
            value: 'RI',
        },
        {
            key: 'RM',
            text: 'Rome',
            value: 'RM',
        },
        {
            key: 'RN',
            text: 'Rimini',
            value: 'RN',
        },
        {
            key: 'RO',
            text: 'Rovigo',
            value: 'RO',
        },
        {
            key: 'SA',
            text: 'Salerno',
            value: 'SA',
        },
        {
            key: 'SI',
            text: 'Siena',
            value: 'SI',
        },
        {
            key: 'SO',
            text: 'Sondrio',
            value: 'SO',
        },
        {
            key: 'SP',
            text: 'La Spezia',
            value: 'SP',
        },
        {
            key: 'SR',
            text: 'Syracuse',
            value: 'SR',
        },
        {
            key: 'SS',
            text: 'Sassari',
            value: 'SS',
        },
        {
            key: 'SV',
            text: 'Savona',
            value: 'SV',
        },
        {
            key: 'TA',
            text: 'Taranto',
            value: 'TA',
        },
        {
            key: 'TE',
            text: 'Teramo',
            value: 'TE',
        },
        {
            key: 'TN',
            text: 'Trento',
            value: 'TN',
        },
        {
            key: 'TO',
            text: 'Turin',
            value: 'TO',
        },
        {
            key: 'TP',
            text: 'Trapani',
            value: 'TP',
        },
        {
            key: 'TR',
            text: 'Terni',
            value: 'TR',
        },
        {
            key: 'TS',
            text: 'Trieste',
            value: 'TS',
        },
        {
            key: 'TV',
            text: 'Treviso',
            value: 'TV',
        },
        {
            key: 'UD',
            text: 'Udine',
            value: 'UD',
        },
        {
            key: 'VA',
            text: 'Varese',
            value: 'VA',
        },
        {
            key: 'VB',
            text: 'Verbano-Cusio-Ossola',
            value: 'VB',
        },
        {
            key: 'VC',
            text: 'Vercelli',
            value: 'VC',
        },
        {
            key: 'VE',
            text: 'Venice',
            value: 'VE',
        },
        {
            key: 'VI',
            text: 'Vicenza',
            value: 'VI',
        },
        {
            key: 'VR',
            text: 'Verona',
            value: 'VR',
        },
        {
            key: 'VS',
            text: 'Medio Campidano',
            value: 'VS',
        },
        {
            key: 'VT',
            text: 'Viterbo',
            value: 'VT',
        },
        {
            key: 'VV',
            text: 'Vibo Valentia',
            value: 'VV',
        },
    ],
    MX: [
        {
            key: 'AG',
            text: 'Aguascalientes',
            value: 'AG',
        },
        {
            key: 'BC',
            text: 'Baja California',
            value: 'BC',
        },
        {
            key: 'BS',
            text: 'Baja California Sur',
            value: 'BS',
        },
        {
            key: 'CH',
            text: 'Chihuahua',
            value: 'CH',
        },
        {
            key: 'CL',
            text: 'Colima',
            value: 'CL',
        },
        {
            key: 'CM',
            text: 'Campeche',
            value: 'CM',
        },
        {
            key: 'CO',
            text: 'Coahuila',
            value: 'CO',
        },
        {
            key: 'CS',
            text: 'Chiapas',
            value: 'CS',
        },
        {
            key: 'DF',
            text: 'Federal District',
            value: 'DF',
        },
        {
            key: 'DG',
            text: 'Durango',
            value: 'DG',
        },
        {
            key: 'GR',
            text: 'Guerrero',
            value: 'GR',
        },
        {
            key: 'GT',
            text: 'Guanajuato',
            value: 'GT',
        },
        {
            key: 'HG',
            text: 'Hidalgo',
            value: 'HG',
        },
        {
            key: 'JA',
            text: 'Jalisco',
            value: 'JA',
        },
        {
            key: 'ME',
            text: 'Mexico State',
            value: 'ME',
        },
        {
            key: 'MI',
            text: 'Michoacán',
            value: 'MI',
        },
        {
            key: 'MO',
            text: 'Morelos',
            value: 'MO',
        },
        {
            key: 'NA',
            text: 'Nayarit',
            value: 'NA',
        },
        {
            key: 'NL',
            text: 'Nuevo León',
            value: 'NL',
        },
        {
            key: 'OA',
            text: 'Oaxaca',
            value: 'OA',
        },
        {
            key: 'PB',
            text: 'Puebla',
            value: 'PB',
        },
        {
            key: 'QE',
            text: 'Querétaro',
            value: 'QE',
        },
        {
            key: 'QR',
            text: 'Quintana Roo',
            value: 'QR',
        },
        {
            key: 'SI',
            text: 'Sinaloa',
            value: 'SI',
        },
        {
            key: 'SL',
            text: 'San Luis Potosí',
            value: 'SL',
        },
        {
            key: 'SO',
            text: 'Sonora',
            value: 'SO',
        },
        {
            key: 'TB',
            text: 'Tabasco',
            value: 'TB',
        },
        {
            key: 'TL',
            text: 'Tlaxcala',
            value: 'TL',
        },
        {
            key: 'TM',
            text: 'Tamaulipas',
            value: 'TM',
        },
        {
            key: 'VE',
            text: 'Veracruz',
            value: 'VE',
        },
        {
            key: 'YU',
            text: 'Yucatán',
            value: 'YU',
        },
        {
            key: 'ZA',
            text: 'Zacatecas',
            value: 'ZA',
        },
    ],
    GB: [
        {
            key: 'ABD',
            text: 'Aberdeenshire',
            value: 'ABD',
        },
        {
            key: 'AGY',
            text: 'Anglesey',
            value: 'AGY',
        },
        {
            key: 'ALD',
            text: 'Alderney',
            value: 'ALD',
        },
        {
            key: 'ANS',
            text: 'Angus',
            value: 'ANS',
        },
        {
            key: 'ARL',
            text: 'Argyll',
            value: 'ARL',
        },
        {
            key: 'AYR',
            text: 'Ayrshire',
            value: 'AYR',
        },
        {
            key: 'BAN',
            text: 'Banffshire',
            value: 'BAN',
        },
        {
            key: 'BDF',
            text: 'Bedfordshire',
            value: 'BDF',
        },
        {
            key: 'BEW',
            text: 'Berwickshire',
            value: 'BEW',
        },
        {
            key: 'BKM',
            text: 'Buckinghamshire',
            value: 'BKM',
        },
        {
            key: 'BOR',
            text: 'Borders',
            value: 'BOR',
        },
        {
            key: 'BRE',
            text: 'Breconshire',
            value: 'BRE',
        },
        {
            key: 'BRK',
            text: 'Berkshire',
            value: 'BRK',
        },
        {
            key: 'BST',
            text: 'Bristol',
            value: 'BST',
        },
        {
            key: 'BUT',
            text: 'County Bute',
            value: 'BUT',
        },
        {
            key: 'CAE',
            text: 'Caernarvonshire',
            value: 'CAE',
        },
        {
            key: 'CAI',
            text: 'Caithness',
            value: 'CAI',
        },
        {
            key: 'CAM',
            text: 'Cambridgeshire',
            value: 'CAM',
        },
        {
            key: 'CEN',
            text: 'Central',
            value: 'CEN',
        },
        {
            key: 'CGN',
            text: 'Cardiganshire',
            value: 'CGN',
        },
        {
            key: 'CHS',
            text: 'Cheshire',
            value: 'CHS',
        },
        {
            key: 'CLK',
            text: 'Clackmannanshire',
            value: 'CLK',
        },
        {
            key: 'CLV',
            text: 'Cleveland',
            value: 'CLV',
        },
        {
            key: 'CMA',
            text: 'Cumbria',
            value: 'CMA',
        },
        {
            key: 'CMN',
            text: 'Carmarthenshire',
            value: 'CMN',
        },
        {
            key: 'CON',
            text: 'Cornwall',
            value: 'CON',
        },
        {
            key: 'CUL',
            text: 'Cumberland',
            value: 'CUL',
        },
        {
            key: 'CWD',
            text: 'Clwyd',
            value: 'CWD',
        },
        {
            key: 'DBY',
            text: 'Derbyshire',
            value: 'DBY',
        },
        {
            key: 'DEN',
            text: 'Denbighshire',
            value: 'DEN',
        },
        {
            key: 'DEV',
            text: 'Devon',
            value: 'DEV',
        },
        {
            key: 'DFD',
            text: 'Dyfed',
            value: 'DFD',
        },
        {
            key: 'DFS',
            text: 'Dumfries-shire',
            value: 'DFS',
        },
        {
            key: 'DGY',
            text: 'Dumfries and Galloway',
            value: 'DGY',
        },
        {
            key: 'DNB',
            text: 'Dunbartonshire',
            value: 'DNB',
        },
        {
            key: 'DOR',
            text: 'Dorset',
            value: 'DOR',
        },
        {
            key: 'DUR',
            text: 'Durham',
            value: 'DUR',
        },
        {
            key: 'ELN',
            text: 'East Lothian',
            value: 'ELN',
        },
        {
            key: 'ESS',
            text: 'Essex',
            value: 'ESS',
        },
        {
            key: 'EYK',
            text: 'East Riding of Yorkshire',
            value: 'EYK',
        },
        {
            key: 'FIF',
            text: 'Fife',
            value: 'FIF',
        },
        {
            key: 'FLN',
            text: 'Flintshire',
            value: 'FLN',
        },
        {
            key: 'GLA',
            text: 'Glamorgan',
            value: 'GLA',
        },
        {
            key: 'GLS',
            text: 'Gloucestershire',
            value: 'GLS',
        },
        {
            key: 'GMP',
            text: 'Grampian',
            value: 'GMP',
        },
        {
            key: 'GNT',
            text: 'Gwent',
            value: 'GNT',
        },
        {
            key: 'GSY',
            text: 'Guernsey',
            value: 'GSY',
        },
        {
            key: 'GTM',
            text: 'Greater Manchester',
            value: 'GTM',
        },
        {
            key: 'GWN',
            text: 'Gwynedd',
            value: 'GWN',
        },
        {
            key: 'HAM',
            text: 'Hampshire',
            value: 'HAM',
        },
        {
            key: 'HEF',
            text: 'Herefordshire',
            value: 'HEF',
        },
        {
            key: 'HLD',
            text: 'Highland',
            value: 'HLD',
        },
        {
            key: 'HRT',
            text: 'Hertfordshire',
            value: 'HRT',
        },
        {
            key: 'HUM',
            text: 'Humberside',
            value: 'HUM',
        },
        {
            key: 'HUN',
            text: 'Huntingdonshire',
            value: 'HUN',
        },
        {
            key: 'IOM',
            text: 'Isle of Man',
            value: 'IOM',
        },
        {
            key: 'IOW',
            text: 'Isle of Wight',
            value: 'IOW',
        },
        {
            key: 'JJ',
            text: 'Edinburgh',
            value: 'JJ',
        },
        {
            key: 'JSY',
            text: 'Jersey',
            value: 'JSY',
        },
        {
            key: 'KCD',
            text: 'Kincardineshire',
            value: 'KCD',
        },
        {
            key: 'KEN',
            text: 'Kent',
            value: 'KEN',
        },
        {
            key: 'KKD',
            text: 'Kirkcudbrightshire',
            value: 'KKD',
        },
        {
            key: 'KRS',
            text: 'Kinross-shire',
            value: 'KRS',
        },
        {
            key: 'LAN',
            text: 'Lancashire',
            value: 'LAN',
        },
        {
            key: 'LEI',
            text: 'Leicestershire',
            value: 'LEI',
        },
        {
            key: 'LIN',
            text: 'Lincolnshire',
            value: 'LIN',
        },
        {
            key: 'LKS',
            text: 'Lanarkshire',
            value: 'LKS',
        },
        {
            key: 'LND',
            text: 'Greater London',
            value: 'LND',
        },
        {
            key: 'LON',
            text: 'City of London',
            value: 'LON',
        },
        {
            key: 'LTN',
            text: 'Lothian',
            value: 'LTN',
        },
        {
            key: 'MDX',
            text: 'Middlesex',
            value: 'MDX',
        },
        {
            key: 'MER',
            text: 'Merionethshire',
            value: 'MER',
        },
        {
            key: 'MGM',
            text: 'Mid Glamorgan',
            value: 'MGM',
        },
        {
            key: 'MGY',
            text: 'Montgomeryshire',
            value: 'MGY',
        },
        {
            key: 'MLN',
            text: 'Midlothian',
            value: 'MLN',
        },
        {
            key: 'MON',
            text: 'Monmouthshire',
            value: 'MON',
        },
        {
            key: 'MOR',
            text: 'Moray',
            value: 'MOR',
        },
        {
            key: 'MSY',
            text: 'Merseyside',
            value: 'MSY',
        },
        {
            key: 'NAI',
            text: 'Nairnshire',
            value: 'NAI',
        },
        {
            key: 'NBL',
            text: 'Northumberland',
            value: 'NBL',
        },
        {
            key: 'NFK',
            text: 'Norfolk',
            value: 'NFK',
        },
        {
            key: 'NTH',
            text: 'Northamptonshire',
            value: 'NTH',
        },
        {
            key: 'NTT',
            text: 'Nottinghamshire',
            value: 'NTT',
        },
        {
            key: 'NV',
            text: 'Inverness-shire',
            value: 'NV',
        },
        {
            key: 'NYK',
            text: 'North Yorkshire',
            value: 'NYK',
        },
        {
            key: 'OKI',
            text: 'Orkney',
            value: 'OKI',
        },
        {
            key: 'OXF',
            text: 'Oxfordshire',
            value: 'OXF',
        },
        {
            key: 'PEE',
            text: 'Peebles-shire',
            value: 'PEE',
        },
        {
            key: 'PEM',
            text: 'Pembrokeshire',
            value: 'PEM',
        },
        {
            key: 'PER',
            text: 'Perthshire',
            value: 'PER',
        },
        {
            key: 'POW',
            text: 'Powys',
            value: 'POW',
        },
        {
            key: 'RAD',
            text: 'Radnorshire',
            value: 'RAD',
        },
        {
            key: 'RFW',
            text: 'Renfrewshire',
            value: 'RFW',
        },
        {
            key: 'ROC',
            text: 'Ross and Cromarty',
            value: 'ROC',
        },
        {
            key: 'ROX',
            text: 'Roxburghshire',
            value: 'ROX',
        },
        {
            key: 'RUT',
            text: 'Rutland',
            value: 'RUT',
        },
        {
            key: 'SAL',
            text: 'Shropshire',
            value: 'SAL',
        },
        {
            key: 'SEL',
            text: 'Selkirkshire',
            value: 'SEL',
        },
        {
            key: 'SFK',
            text: 'Suffolk',
            value: 'SFK',
        },
        {
            key: 'SGM',
            text: 'South Glamorgan',
            value: 'SGM',
        },
        {
            key: 'SHI',
            text: 'Shetland',
            value: 'SHI',
        },
        {
            key: 'SOM',
            text: 'Somerset',
            value: 'SOM',
        },
        {
            key: 'SRK',
            text: 'Sark',
            value: 'SRK',
        },
        {
            key: 'SRY',
            text: 'Surrey',
            value: 'SRY',
        },
        {
            key: 'SSX',
            text: 'Sussex',
            value: 'SSX',
        },
        {
            key: 'STD',
            text: 'Strathclyde',
            value: 'STD',
        },
        {
            key: 'STI',
            text: 'Stirlingshire',
            value: 'STI',
        },
        {
            key: 'STS',
            text: 'Staffordshire',
            value: 'STS',
        },
        {
            key: 'SUT',
            text: 'Sutherland',
            value: 'SUT',
        },
        {
            key: 'SXE',
            text: 'East Sussex',
            value: 'SXE',
        },
        {
            key: 'SXW',
            text: 'West Sussex',
            value: 'SXW',
        },
        {
            key: 'SYK',
            text: 'South Yorkshire',
            value: 'SYK',
        },
        {
            key: 'TAY',
            text: 'Tayside',
            value: 'TAY',
        },
        {
            key: 'TWR',
            text: 'Tyne and Wear',
            value: 'TWR',
        },
        {
            key: 'WAR',
            text: 'Warwickshire',
            value: 'WAR',
        },
        {
            key: 'WESTISES',
            text: 'Western Isles',
            value: 'WESTISES',
        },
        {
            key: 'WGM',
            text: 'West Glamorgan',
            value: 'WGM',
        },
        {
            key: 'WIG',
            text: 'Wigtownshire',
            value: 'WIG',
        },
        {
            key: 'WIL',
            text: 'Wiltshire',
            value: 'WIL',
        },
        {
            key: 'WLN',
            text: 'West Lothian',
            value: 'WLN',
        },
        {
            key: 'WMD',
            text: 'West Midlands',
            value: 'WMD',
        },
        {
            key: 'WOR',
            text: 'Worcestershire',
            value: 'WOR',
        },
        {
            key: 'WYK',
            text: 'West Yorkshire',
            value: 'WYK',
        },
    ],
    US: [
        {
            key: 'AA',
            text: 'Armed Forces America',
            value: 'AA',
        },
        {
            key: 'AE',
            text: 'Armed Forces Europe',
            value: 'AE',
        },
        {
            key: 'AK',
            text: 'Alaska',
            value: 'AK',
        },
        {
            key: 'AL',
            text: 'Alabama',
            value: 'AL',
        },
        {
            key: 'AP',
            text: 'Armed Forces Pacific',
            value: 'AP',
        },
        {
            key: 'AR',
            text: 'Arkansas',
            value: 'AR',
        },
        {
            key: 'AS',
            text: 'American Samoa',
            value: 'AS',
        },
        {
            key: 'AZ',
            text: 'Arizona',
            value: 'AZ',
        },
        {
            key: 'CA',
            text: 'California',
            value: 'CA',
        },
        {
            key: 'CO',
            text: 'Colorado',
            value: 'CO',
        },
        {
            key: 'CT',
            text: 'Connecticut',
            value: 'CT',
        },
        {
            key: 'DC',
            text: 'District of Columbia',
            value: 'DC',
        },
        {
            key: 'DE',
            text: 'Delaware',
            value: 'DE',
        },
        {
            key: 'FL',
            text: 'Florida',
            value: 'FL',
        },
        {
            key: 'FM',
            text: 'Federated Micronesia',
            value: 'FM',
        },
        {
            key: 'GA',
            text: 'Georgia',
            value: 'GA',
        },
        {
            key: 'GU',
            text: 'Guam',
            value: 'GU',
        },
        {
            key: 'HI',
            text: 'Hawaii',
            value: 'HI',
        },
        {
            key: 'IA',
            text: 'Iowa',
            value: 'IA',
        },
        {
            key: 'ID',
            text: 'Idaho',
            value: 'ID',
        },
        {
            key: 'IL',
            text: 'Illinois',
            value: 'IL',
        },
        {
            key: 'IN',
            text: 'Indiana',
            value: 'IN',
        },
        {
            key: 'KS',
            text: 'Kansas',
            value: 'KS',
        },
        {
            key: 'KY',
            text: 'Kentucky',
            value: 'KY',
        },
        {
            key: 'LA',
            text: 'Louisiana',
            value: 'LA',
        },
        {
            key: 'MA',
            text: 'Massachusetts',
            value: 'MA',
        },
        {
            key: 'MD',
            text: 'Maryland',
            value: 'MD',
        },
        {
            key: 'ME',
            text: 'Maine',
            value: 'ME',
        },
        {
            key: 'MH',
            text: 'Marshall Islands',
            value: 'MH',
        },
        {
            key: 'MI',
            text: 'Michigan',
            value: 'MI',
        },
        {
            key: 'MN',
            text: 'Minnesota',
            value: 'MN',
        },
        {
            key: 'MO',
            text: 'Missouri',
            value: 'MO',
        },
        {
            key: 'MP',
            text: 'Northern Mariana Islands',
            value: 'MP',
        },
        {
            key: 'MS',
            text: 'Mississippi',
            value: 'MS',
        },
        {
            key: 'MT',
            text: 'Montana',
            value: 'MT',
        },
        {
            key: 'NC',
            text: 'North Carolina',
            value: 'NC',
        },
        {
            key: 'ND',
            text: 'North Dakota',
            value: 'ND',
        },
        {
            key: 'NE',
            text: 'Nebraska',
            value: 'NE',
        },
        {
            key: 'NH',
            text: 'New Hampshire',
            value: 'NH',
        },
        {
            key: 'NJ',
            text: 'New Jersey',
            value: 'NJ',
        },
        {
            key: 'NM',
            text: 'New Mexico',
            value: 'NM',
        },
        {
            key: 'NV',
            text: 'Nevada',
            value: 'NV',
        },
        {
            key: 'NY',
            text: 'New York',
            value: 'NY',
        },
        {
            key: 'OH',
            text: 'Ohio',
            value: 'OH',
        },
        {
            key: 'OK',
            text: 'Oklahoma',
            value: 'OK',
        },
        {
            key: 'OR',
            text: 'Oregon',
            value: 'OR',
        },
        {
            key: 'PA',
            text: 'Pennsylvania',
            value: 'PA',
        },
        {
            key: 'PR',
            text: 'Puerto Rico',
            value: 'PR',
        },
        {
            key: 'PW',
            text: 'Palau',
            value: 'PW',
        },
        {
            key: 'RI',
            text: 'Rhode Island',
            value: 'RI',
        },
        {
            key: 'SC',
            text: 'South Carolina',
            value: 'SC',
        },
        {
            key: 'SD',
            text: 'South Dakota',
            value: 'SD',
        },
        {
            key: 'TN',
            text: 'Tennessee',
            value: 'TN',
        },
        {
            key: 'TX',
            text: 'Texas',
            value: 'TX',
        },
        {
            key: 'UM',
            text: 'United States Minor Outlying Islands',
            value: 'UM',
        },
        {
            key: 'UT',
            text: 'Utah',
            value: 'UT',
        },
        {
            key: 'VA',
            text: 'Virginia',
            value: 'VA',
        },
        {
            key: 'VI',
            text: 'Virgin Islands',
            value: 'VI',
        },
        {
            key: 'VT',
            text: 'Vermont',
            value: 'VT',
        },
        {
            key: 'WA',
            text: 'Washington',
            value: 'WA',
        },
        {
            key: 'WI',
            text: 'Wisconsin',
            value: 'WI',
        },
        {
            key: 'WV',
            text: 'West Virginia',
            value: 'WV',
        },
        {
            key: 'WY',
            text: 'Wyoming',
            value: 'WY',
        },
    ],
}));
const getStatesByCountry = (country) => {
    return exports.StateMap.get(country);
};
exports.getStatesByCountry = getStatesByCountry;
exports.LeadCaptureFormCountryList = checkout_1.COUNTRIES_LIST.map(({ text, value }) => ({
    text,
    countryCode: value,
    key: text.replace(' ', '_'),
    value: text.replace(' ', '_'),
}));
//# sourceMappingURL=index.js.map